export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nouveaux contrats"])},
        "no_results": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aucun contrat sur la période sélectionnée"])},
        "previous_period": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Période précédente"])}
      },
      "en": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["New contracts"])},
        "no_results": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No contracts for the selected period"])},
        "previous_period": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Previous period"])}
      }
    }
  })
}
